import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getNotifications, markNotifRead, markAllRead } from "../services/api";
import { Bell, CheckCheck, Gem, ClipboardCheck, Cake, PartyPopper, Undo2, XCircle, Send } from "lucide-react";

const ICONS = {
  "Gems awarded": Gem, "Birthday Gems issued": Cake, "Anniversary Gems issued": PartyPopper,
  "Request approved": ClipboardCheck, "Request denied": XCircle, "Request sent back for more information": Undo2,
  "Request needs HR review": Send, "Request needs Director final approval": Send, "New request submitted": Send,
};
const fmt = (iso) => new Date(iso).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });

export default function Notifications() {
  const navigate = useNavigate();
  const [list, setList] = useState([]);
  const load = () => getNotifications().then(setList).catch(() => {});
  useEffect(() => { load(); }, []);

  const open = async (n) => {
    await markNotifRead(n.id);
    await load();
    if (n.relatedRequestId) navigate(`/app/requests/${n.relatedRequestId}`);
  };
  const allRead = async () => { await markAllRead(); await load(); };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <div className="flex items-end justify-between gap-4">
        <div>
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-vault-panel/50">Inbox</div>
          <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-vault-panel mt-1">Notifications</h1>
        </div>
        <button onClick={allRead} className="inline-flex items-center gap-2 rounded-2xl bg-vault-panel text-vault-cream font-semibold px-4 py-2.5 text-sm hover:bg-vault-panel2 transition-colors">
          <CheckCheck className="h-4 w-4" /> Mark all read
        </button>
      </div>

      <div className="rounded-3xl bg-vault-panel divide-y divide-white/5">
        {list.length === 0 ? (
          <div className="py-16 text-center text-vault-subtle"><Bell className="h-8 w-8 mx-auto mb-3 opacity-50" />You're all caught up.</div>
        ) : list.map((n) => {
          const Icon = ICONS[n.type] || Bell;
          return (
            <button key={n.id} onClick={() => open(n)} className="w-full text-left flex items-start gap-4 p-5 hover:bg-vault-panel2/50 transition-colors">
              <div className={`h-10 w-10 rounded-2xl grid place-items-center shrink-0 ${n.isRead ? "bg-vault-panel2 text-vault-subtle" : "bg-vault-accent text-vault-panel"}`}>
                <Icon className="h-5 w-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold text-vault-cream">{n.title}</span>
                  {!n.isRead && <span className="h-2 w-2 rounded-full bg-vault-accent" />}
                </div>
                <div className="text-sm text-vault-subtle mt-0.5">{n.message}</div>
                <div className="text-xs text-vault-subtle/70 mt-1">{fmt(n.createdAt)}</div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
